export default __webpack_public_path__ + "static/depopxadidas_1280x565-96f016b3bcdb6b45adcac3a3f79b7b30.jpg";